var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeatDiaryNewProgEntry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#784ace;}.cls-2{fill:#d4bff6;}.cls-3{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heat_cycle_progesterone_new_entry"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 300.33,
    cy: 299.93,
    r: 299.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M306.52,128.45a77,77,0,0,0-25.11-27.78h0A60.35,60.35,0,0,0,247.63,90.1H177.22a25.38,25.38,0,0,0-25.75,25.76V294.34a25.92,25.92,0,0,0,6.75,18.1A23.4,23.4,0,0,0,176,320.1c7.31,0,13.37-2.5,18-7.43s6.82-11,6.82-18.33V242.9h46.81a60.4,60.4,0,0,0,33.78-10.57,76.57,76.57,0,0,0,25.12-28,80.78,80.78,0,0,0,0-75.92ZM265.1,166.5a32.72,32.72,0,0,1-2.93,13.67,29.94,29.94,0,0,1-7.48,10.43h0c-2.53,2.19-4.84,3.25-7.05,3.25H200.82v-54.4h46.81c2.25,0,4.59,1,7.13,3.17a28.25,28.25,0,0,1,7.4,10.2A33,33,0,0,1,265.1,166.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M370.29,523.45A58.33,58.33,0,0,1,312,465.19V418H263.67a56.8,56.8,0,0,1,0-113.6H312V257.35a58.26,58.26,0,1,1,116.52,0v47.08h56.16a56.8,56.8,0,1,1,0,113.6H428.55v47.16A58.33,58.33,0,0,1,370.29,523.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M370.29,214.09a43.39,43.39,0,0,1,43.26,43.26v62.08h71.16a41.92,41.92,0,0,1,41.8,41.8h0a41.92,41.92,0,0,1-41.8,41.8H413.55v62.16a43.26,43.26,0,1,1-86.52,0V403H263.67a41.92,41.92,0,0,1-41.8-41.8h0a41.92,41.92,0,0,1,41.8-41.8H327V257.35a43.39,43.39,0,0,1,43.26-43.26m0-30A73.34,73.34,0,0,0,297,257.35v32.08H263.67a71.8,71.8,0,0,0,0,143.6H297v32.16a73.26,73.26,0,1,0,146.52,0V433h41.16a71.8,71.8,0,1,0,0-143.6H443.55V257.35a73.34,73.34,0,0,0-73.26-73.26Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatDiaryNewProgEntry);
export default __webpack_public_path__ + "static/media/heat_diary_new_prog_entry.8e650bf9093a8102c131c89a6b98df31.svg";
export { ForwardRef as ReactComponent };